/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_NoteInputs */

const ja_playdata_about_coverage_note = /** @type {(inputs: Playdata_About_Coverage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平均同時視聴者数が100人を下回るストリーミング配信は、集計対象から除外されています。`)
};

const en_playdata_about_coverage_note = /** @type {(inputs: Playdata_About_Coverage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasts with an average number of simultaneous viewers less than 100 are excluded from data aggregation.`)
};

/**
* | output |
* | --- |
* | "Broadcasts with an average number of simultaneous viewers less than 100 are excluded from data aggregation." |
*
* @param {Playdata_About_Coverage_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_note = /** @type {((inputs?: Playdata_About_Coverage_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_note(inputs)
	return en_playdata_about_coverage_note(inputs)
});